//
// IMPORTS
//

// Base URL for the API
import { reportUrl } from '@/constants'

import { httpRequest } from '@/services/api'

//
//
//
// ENDPOINTS E FUNÇÕES PARA RELATÓRIOS
//
//
//

const apiCheckReportStatus = endpointAddress => httpRequest({ method: 'GET', url: `${reportUrl}/${endpointAddress}` })

const apiOpenReport = (generateUrl, complete = false) => window.open(complete ? generateUrl : `${reportUrl}/${generateUrl}`)

const apiDownloadTimesheetPDF = async (endpoint, token) => {
  try {
    const response = await fetch(`${reportUrl}/api/${endpoint}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf'
      }
    })

    if (!response.ok) {
      throw new Error('Erro ao gerar PDF')
    }

    const blob = await response.blob()

    const contentDisposition = response.headers.get('content-disposition')
    let filename = 'folha-de-ponto.pdf'

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '')
      }
    }

    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)

    return { code: 1, message: 'PDF gerado com sucesso' }
  } catch (error) {
    console.error('Erro ao baixar PDF:', error)
    return { code: 0, message: error.message || 'Erro ao gerar PDF' }
  }
}

//
//
//
// SAÍDA
//
//
//

export {
  apiCheckReportStatus,
  apiOpenReport,
  apiDownloadTimesheetPDF,
}
